export default __webpack_public_path__ + "static/media/noboarding.e57bfe08.png";